// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"EditLabelsNavItem_NavigationItem__mi3uT"};